"use client";

import { useSession, signIn, signOut } from "next-auth/react";
import { useEffect, useRef, useState } from "react";

export default function SessionGuard({ children }: { children: React.ReactNode }) {
    const { data: session } = useSession();
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [iniciandoSesion, setIniciandoSesion] = useState(false);
    const cierreSesionIniciado = useRef(false);

    useEffect(() => {
        if (session?.error === "RefreshAccessTokenError" && !cierreSesionIniciado.current) {
            cierreSesionIniciado.current = true;
            setMostrarAlerta(true);
            void signOut({ redirect: false }).catch((error: unknown) => {
                console.error("No se pudo cerrar la sesión expirada.", error);
            });
        }
    }, [session?.error]);

    async function iniciarSesionNuevamente() {
        setIniciandoSesion(true);
        try {
            await signIn("keycloak", { callbackUrl: "/gestion" });
        } catch (error) {
            console.error("No se pudo iniciar sesión nuevamente.", error);
            setIniciandoSesion(false);
        }
    }

    return (
        <>
            {/* Interfaz visual de la alerta de expiración */}
            {mostrarAlerta && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm">
                    <div className="card p-4 shadow-lg text-center max-w-sm w-full mx-3 border-top-danger border-top-3 animated fadeIn">
                        <div className="card-body">
                            <div className="text-danger mb-3">
                                {/* Icono de advertencia */}
                                <svg xmlns="http://w3.org" width="48" height="48" fill="currentColor" className="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>
                                </svg>
                            </div>
                            <h4 className="card-title text-dark fw-bold">Tu sesión ha expirado</h4>
                            <p className="card-text text-muted mt-2">
                                Por motivos de seguridad y debido a inactividad, se ha cerrado tu sesion en el sistema Hemerográfica.
                            </p>
                            <div className="mt-3">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={iniciarSesionNuevamente}
                                    disabled={iniciandoSesion}
                                >
                                    {iniciandoSesion ? "Redirigiendo..." : "Iniciar sesión nuevamente"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Renderiza el resto de la aplicación normalmente */}
            {children}
        </>
    );
}
